// app/design/[templateName]/[index]/WeddingCardEditorWrapper.tsx
"use client";

import dynamic from "next/dynamic";
import { DesignTemplateCardModel } from "@/app/models/DesignTemplateModel";
import { useEffect, useState } from "react";

// ✅ dynamically import both editors (Fabric.js needs browser APIs)
const WeddingCardEditor = dynamic(() => import("./WeddingCardEditor"), {
  ssr: false,
});
const WeddingCardEditorMobile = dynamic(
  () => import("./WeddingCardEditorMobile"),
  { ssr: false }
);

type Props = {
  template: DesignTemplateCardModel;
};

export default function WeddingCardEditorWrapper({ template }: Props) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768); // or your breakpoint
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  if (isMobile) {
    // Mobile web specific component
    return <WeddingCardEditorMobile template={template} />;
  }

  // Desktop web component

  return <WeddingCardEditor template={template} />;
}
